module.exports = __webpack_public_path__ + "img/1529643383.fdc2e84d.jpg";